import { Calendar, Clock } from "lucide-react";
import { cn } from "@/lib/utils";

export type ScheduleType = 'seasonal' | 'daily' | null;

interface ScheduleTypeSelectorProps {
  value: ScheduleType;
  onChange: (type: ScheduleType) => void;
}

const cards = [
  {
    type: 'seasonal' as const,
    icon: Calendar,
    title: 'Seasonal / Weekly',
    description: 'Repeating weekly schedule — flights operate on specific days of the week over a date range (e.g. Air Niugini seasonal timetable)',
  },
  {
    type: 'daily' as const,
    icon: Clock,
    title: 'Daily Operational',
    description: 'Single day schedule — all flights operate on one specific date (e.g. Airlines PNG daily dispatch)',
  },
];

export function ScheduleTypeSelector({ value, onChange }: ScheduleTypeSelectorProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium leading-none">Schedule Type</label>
      <div className="grid grid-cols-2 gap-4">
        {cards.map((card) => {
          const selected = value === card.type;
          const Icon = card.icon;
          return (
            <button
              key={card.type}
              type="button"
              onClick={() => onChange(card.type)}
              className={cn(
                "flex flex-col items-start gap-3 rounded-lg border-2 p-4 text-left transition-all",
                selected
                  ? "border-transparent"
                  : "border-transparent hover:opacity-90"
              )}
              style={{
                backgroundColor: selected ? '#FFDE21' : '#0d1b4b',
                color: selected ? '#1a1a1a' : '#ffffff',
              }}
            >
              <div className="flex items-center gap-2">
                <Icon className="h-5 w-5" />
                <span className="font-semibold">{card.title}</span>
              </div>
              <p className="text-xs leading-relaxed opacity-80">
                {card.description}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
